import { translate } from '@openclassrooms/translations';

import OrientationSrc from '../_components/Steps/images/orientation.svg';
import StartDateSrc from '../_components/Steps/images/start-date.svg';
import OnboardingSrc from '../_components/Steps/images/onboarding.svg';
import SkillAcquisitionSrc from '../_components/Steps/images/skill-acquisition.svg';
import JuryDiplomaSrc from '../_components/Steps/images/jury-diploma.svg';
import CareerSrc from '../_components/Steps/images/career.svg';

import ManonSrc from '../_components/IntroTestimonials/images/Manon.png';
import CamilleSrc from '../_components/IntroTestimonials/images/Camille.png';
import HafidSrc from '../_components/IntroTestimonials/images/Camille.png';
import AliceSrc from '../_components/IntroTestimonials/images/Camille.png';

import { ServiceBlocks } from '../_components/Steps';
import SupportServiceCard from '../_components/Steps/SupportServiceCard';

export const ANCHOR_CONTACT_FORM = 'contact_form';

export type Step = {
  slug: string;
  order: number;
  label: string;
  dataEvent: string;
  dataTestId: string;
  illustrationSrc: string;
  title: string;
  intro: string;
  quote: string;
  testimonialPictureSrc: string;
  description: string;
  status: string;
  video: {
    fr: string;
    en: string;
  };
  videoTitle: string;
  services?: React.ComponentType;
  additionalContent?: React.ComponentType;
};

export default () => [
  {
    slug: 'orientation',
    order: 0,
    label: translate('student_experience.stepper.one'),
    dataEvent: 'Button|Clicked|orientation',
    dataTestId: 'orientationStep',
    illustrationSrc: OrientationSrc,
    title: translate('student_experience.stepper_one.keyword'),
    intro: translate('student_experience.stepper_one.text'),
    quote: translate('student_experience.stepper_one.quote'),
    testimonialPictureSrc: ManonSrc,
    description: translate('student_experience.stepper_one.quote_description'),
    status: translate('student_experience.stepper_one.quote_description2'),
    video: {
      fr: 'https://player.vimeo.com/video/616076246?h=d30f76c7d0',
      en: 'https://player.vimeo.com/video/616075068?h=284a960a63',
    },
    videoTitle: translate('student_experience.stepper_one.keyword'),
  },
  {
    slug: 'startDate',
    order: 1,
    label: translate('student_experience.stepper.two'),
    dataEvent: 'Button|Clicked|start-date',
    dataTestId: 'startDateStep',
    illustrationSrc: StartDateSrc,
    title: translate('student_experience.stepper_two.keyword'),
    intro: translate('student_experience.stepper_two.text'),
    quote: translate('student_experience.stepper_two.quote'),
    testimonialPictureSrc: CamilleSrc,
    description: translate('student_experience.stepper_two.quote_description'),
    status: translate('student_experience.stepper_two.quote_description2'),
    video: {
      fr: 'https://player.vimeo.com/video/616076295?h=f42fc2d18b',
      en: 'https://player.vimeo.com/video/616075221?h=49a77e9e5e',
    },
    videoTitle: translate('student_experience.stepper_two.keyword'),
  },
  {
    slug: 'onboarding',
    order: 2,
    label: translate('student_experience.stepper.three'),
    dataEvent: 'Button|Clicked|onboarding',
    dataTestId: 'onboardingStep',
    illustrationSrc: OnboardingSrc,
    title: translate('student_experience.stepper_three.keyword'),
    intro: translate('student_experience.stepper_three.text'),
    quote: translate('student_experience.stepper_three.quote'),
    testimonialPictureSrc: HafidSrc,
    description: translate('student_experience.stepper_three.quote_description'),
    status: translate('student_experience.stepper_three.quote_description2'),
    video: {
      fr: 'https://player.vimeo.com/video/616076352?h=5796d1ec83',
      en: 'https://player.vimeo.com/video/616074797?h=5cfa7eac72',
    },
    videoTitle: translate('student_experience.stepper_three.keyword'),
  },
  {
    slug: 'skillAcquisition',
    order: 3,
    label: translate('student_experience.stepper.four'),
    dataEvent: 'Button|Clicked|skill-acquisition',
    dataTestId: 'skillAcquisitionStep',
    illustrationSrc: SkillAcquisitionSrc,
    title: translate('student_experience.stepper_four.keyword'),
    intro: translate('student_experience.stepper_four.text'),
    quote: translate('student_experience.stepper_four.quote'),
    testimonialPictureSrc: AliceSrc,
    description: translate('student_experience.stepper_four.quote_description'),
    status: translate('student_experience.stepper_four.quote_description2'),
    video: {
      fr: 'https://player.vimeo.com/video/616075662?h=91ea9923fe',
      en: 'https://player.vimeo.com/video/616074880?h=df2572a444',
    },
    videoTitle: translate('student_experience.stepper_four.keyword'),
    services: ServiceBlocks,
    additionalContent: SupportServiceCard,
  },
  {
    slug: 'juryDiploma',
    order: 4,
    label: translate('student_experience.stepper.five'),
    dataEvent: 'Button|Clicked|jury-diploma',
    dataTestId: 'juryDiplomaStep',
    illustrationSrc: JuryDiplomaSrc,
    title: translate('student_experience.stepper_five.keyword'),
    intro: translate('student_experience.stepper_five.text'),
    quote: translate('student_experience.stepper_five.quote'),
    testimonialPictureSrc: CamilleSrc,
    description: translate('student_experience.stepper_five.quote_description'),
    status: translate('student_experience.stepper_five.quote_description2'),
    video: {
      fr: 'https://player.vimeo.com/video/616075862?h=fc8d58ebc5',
      en: 'https://player.vimeo.com/video/616074953?h=4997ed6f73',
    },
    videoTitle: translate('student_experience.stepper_five.keyword'),
  },
  {
    slug: 'career',
    order: 5,
    label: translate('student_experience.stepper.six'),
    dataEvent: 'Button|Clicked|career',
    dataTestId: 'careerStep',
    illustrationSrc: CareerSrc,
    title: translate('student_experience.stepper_six.keyword'),
    intro: translate('student_experience.stepper_six.text'),
    quote: translate('student_experience.stepper_six.quote'),
    testimonialPictureSrc: HafidSrc,
    description: translate('student_experience.stepper_six.quote_description'),
    status: translate('student_experience.stepper_six.quote_description2'),
    video: {
      fr: 'https://player.vimeo.com/video/616076044?h=f05eb44087',
      en: 'https://player.vimeo.com/video/616074993?h=bbb7616430',
    },
    videoTitle: translate('student_experience.stepper_six.keyword'),
  },
];
